import {useCallback} from 'react';

import {ComOrganizationList} from '~shared/models';

import toaster from '~ui/utils/toaster';
import {i18n} from '~ui/components/ChangeContext/i18n';
import {changeContext} from '~ui/services/organizations';

export function useChangeContext(organizations: ComOrganizationList, sk: string) {
    const handleChangeContext = useCallback(
        (orgId: string) => {
            return changeContext(organizations, orgId, sk).catch((e) => {
                console.error(e);
                toaster.createToast({
                    type: 'error',
                    name: 'change-context',
                    title: i18n('error-change-context'),
                });
            });
        },
        [organizations, sk],
    );

    return {handleChangeContext};
}
